module.exports = __webpack_public_path__ + "img/logo-teamio.ef95a1e0.png";